import { cn } from '@/shared/lib/utils';
import * as React from 'react';

/** Figma 카드: 흰 배경 · 테두리 #eaeaea · radius 16 · 패딩 24/22 */
export const Card = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'rounded-card border border-line bg-surface px-4 py-5 lg:px-6 lg:py-[22px]',
      className,
    )}
    {...props}
  />
);

/** 카드 제목 줄 — 제목 16 Bold + 보조 12, 우측 액션 */
export const CardHeader = ({
  title,
  description,
  actions,
  className,
}: {
  title: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      'flex flex-col gap-3 lg:flex-row lg:items-center lg:gap-2.5',
      className,
    )}
  >
    <div className="flex flex-col gap-[3px]">
      <h2 className="text-base leading-6 font-bold text-ink">{title}</h2>
      {description && (
        <p className="text-xs leading-[18px] text-ink-5">{description}</p>
      )}
    </div>
    {actions && (
      <div className="flex flex-wrap items-center gap-2 lg:ml-auto">
        {actions}
      </div>
    )}
  </div>
);
